import { forwardRef } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TextInputField } from '@brighte/form-components';
import { FormContactFieldsType } from '../ContactFields';
import { SecureFields } from '../SecureCode';

type SecureCodeProps = {
  name: keyof SecureFields;
} & Pick<UseFormReturn<FormContactFieldsType>, 'control'>;

const SecureCode = forwardRef<HTMLInputElement, SecureCodeProps>(({ name, control }, ref) => {
  return (
    <TextInputField name={name} control={control} inputRef={ref} label="" type="tel" data={{ testId: 'secure-code' }} />
  );
});

SecureCode.displayName = 'SecureCode';

export default SecureCode;
